import { Box, Typography } from '@mui/material'
import React from 'react'
import { HeatmapDefinition } from 'store/ducks/report/types'

interface HeatmapPreviewProps {
  heatmap: HeatmapDefinition
  previewUrl?: string
  onClick?: () => void
}

const HeatmapPreview: React.FC<HeatmapPreviewProps> = ({
  heatmap,
  previewUrl,
  onClick
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        height: 260,
        borderRadius: 1,
        overflow: 'hidden',
        bgcolor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: previewUrl ? 'pointer' : 'default'
      }}
      onClick={onClick}
    >
      {previewUrl ? (
        <Box
          component="img"
          src={previewUrl}
          alt={heatmap.name || heatmap.fileName}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
        />
      ) : (
        <Typography variant="caption" color="textSecondary" display="block">
          File: {heatmap.fileName}
        </Typography>
      )}
    </Box>
  )
}

export default HeatmapPreview
